import axiosClient from "./axiosClient";

export const createOrder = async (orderData) => {
  const response = await axiosClient.post("/orders", orderData);

  return response.data;
};

export const getOrderById = async (orderId) => {
  const response = await axiosClient.get(`/orders/${orderId}`);

  return response.data;
};
